'use client';
import { Suspense, use, type ReactNode } from 'react';
import { browser } from 'react-dom';

function Gate({ reason, children }: { reason: string; children: ReactNode }) {
  use(browser(reason));
  return <>{children}</>;
}
export function BrowserOnly({
  reason,
  fallback,
  children,
}: {
  reason: string;
  fallback: ReactNode;
  children: ReactNode;
}) {
  return (
    <Suspense fallback={fallback}>
      <Gate reason={reason}>{children}</Gate>
    </Suspense>
  );
}
